module.exports = __webpack_public_path__ + "img/user-photo.31632e3b.svg";